

import React from "react";
import ContactForm from "../ContactFrom/ContactForm";
import icon1 from "../../images/icons/icon_map_mark_2.svg";
import icon2 from "../../images/icons/icon_calling_2.svg";
import icon3 from "../../images/icons/icon_mail_3.svg";
import icon4 from "../../images/icons/icon_calendar_2.svg";

const ContactSection = () => {
  return (
    <section className="contact_section section_space bg-light">
      <div className="container">
        {/* ====== Row 1 : Addresses ====== */}
        <div className="row contact_info_box g-4 mb-4">
          {/* Alwar Address */}
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="iconbox_block text-center p-4 h-100">
              <div className="iconbox_icon">
                <img src={icon1} alt="Map Mark SVG Icon" />
              </div>
              <div className="iconbox_content">
                <h3 className="iconbox_title">Alwar Office</h3>
                <p className="mb-2">
                  Shiv Complex, Near Dussehra Maidan, Alwar (Rajasthan)
                </p>
                <p className="mb-3">
                  Phone:{" "}
                  <a href="tel:+918094094653" className="text-primary">
                    +91 80940 94653
                  </a>
                </p>
                <div className="gmap_canvas">
                  <iframe
                    title="Alwar Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3536.3758778193296!2d76.61286727546295!3d27.581873976254734!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3972992292a6a055%3A0x802531db58dac6de!2sRashTech%20Info%20%E2%80%93%20Software%20Development%20Company%20in%20Delhi%20NCR!5e0!3m2!1sen!2sin!4v1755067055792!5m2!1sen!2sin"
                    height="60"
                    style={{
                      border: 0,
                      width: "100%",
                      height: "225px",
                      borderRadius: "8px",
                    }}
                    allowFullScreen=""
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>

          {/* Vietnam Address */}
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="iconbox_block text-center p-4 h-100">
              <div className="iconbox_icon">
                <img src={icon1} alt="Map Mark SVG Icon" />
              </div>
              <div className="iconbox_content">
                <h3 className="iconbox_title">Vietnam Office</h3>
                <p className="mb-2">
                  283/37 Phạm Ngũ Lão, Phường Bến Thành, <br />
                  Quận 1, Hồ Chí Minh 71000, Vietnam
                </p>
                <p className="mb-3">
                  Phone:{" "}
                  <a href="tel:+84869235730" className="text-primary">
                    +84 869 235 730
                  </a>
                </p>
                <div className="gmap_canvas">
                  {/* <iframe
                    title="Vietnam Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.4502255788597!2d106.6922731745186!3d10.776530089373835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752f47c18f9b0f%3A0x6a0d1a9f3d1f0!2sPh%E1%BA%A1m%20Ng%C5%A9%20L%C3%A3o%2C%20Qu%E1%BA%ADn%201%2C%20H%E1%BB%93%20Ch%C3%AD%20Minh%2C%20Vietnam!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
                    
                    style={{ border: 0, width: "100%", height:'225px', borderRadius: "8px" }}
                    allowFullScreen=""
                    loading="lazy"
                  ></iframe> */}
                  <iframe
                    title="Vietnam Map"
                    src="https://www.google.com/maps?q=10.7677379,106.6887892&hl=en&z=15&output=embed"
                    style={{
                      border: 0,
                      width: "100%",
                      height: "225px",
                      borderRadius: "8px",
                    }}
                    allowFullScreen=""
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Jaipur Address */}
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="iconbox_block text-center p-4 h-100">
              <div className="iconbox_icon">
                <img src={icon1} alt="Map Mark SVG Icon" />
              </div>
              <div className="iconbox_content">
                <h3 className="iconbox_title">Jaipur Office</h3>
                <p className="mb-2">
                  Near Ayyappa Mandir Marg, Mahaveer Nagar, <br />
                  Gopal Pura Mode, Jaipur (Raj.) 302018
                </p>
                <p className="mb-3">
                  Phone:{" "}
                  <a href="tel:+918094094653" className="text-primary">
                    +91 80940 94653
                  </a>
                </p>
                <div className="gmap_canvas">
                  <iframe
                    title="Jaipur Map"
                    src="https://www.google.com/maps?q=26.86097,75.790682&hl=en&z=15&output=embed"
                    style={{
                      border: 0,
                      width: "100%",
                      height: "225px",
                      borderRadius: "8px",
                    }}
                    allowFullScreen=""
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ====== Row 2 : Contact / Email / Visit ====== */}
        <div className="row contact_info_box g-4 mb-5">
          {/* Contact */}
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="iconbox_block text-center p-4 h-100">
              <div className="iconbox_icon">
                <img src={icon2} alt="Calling SVG Icon" />
              </div>
              <div className="iconbox_content">
                <h3 className="iconbox_title">Contact</h3>
                <p className="mb-0">
                  <a href="tel:+918094094653" className="text-primary">
                    +91 80940 94653
                  </a>
                </p>
              </div>
            </div>
          </div>

          {/* Email */}
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="iconbox_block text-center p-4 h-100">
              <div className="iconbox_icon">
                <img src={icon3} alt="User Check SVG Icon" />
              </div>
              <div className="iconbox_content">
                <h3 className="iconbox_title">Email</h3>
                <p className="mb-0">
                  <a
                    href="mailto:info@rashtechinfo.com"
                    className="text-primary"
                  >
                    info@rashtechinfo.com
                  </a>
                </p>
              </div>
            </div>
          </div>

          {/* Visit Between */}
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="iconbox_block text-center p-4 h-100">
              <div className="iconbox_icon">
                <img src={icon4} alt="Calendar SVG Icon" />
              </div>
              <div className="iconbox_content">
                <h3 className="iconbox_title">Visit Between</h3>
                <p className="mb-0">Mon - Fri: 9.00-6.00</p>
                <p className="mb-0">Sat - Sun: Closed</p>
              </div>
            </div>
          </div>
        </div>

        {/* ====== Contact Form Section ====== */}
        <div className="section_space pb-0">
          <div className="row justify-content-lg-between">
            <div className="col-lg-12">
              <div className="contact_form mb-0">
                <h3 className="details_item_info_title mb-1">
                  Send Us A Message
                </h3>
                <p className="mb-5">
                  Give us chance to serve and bring magic to your brand.
                </p>
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
